<div class="inputs-wrapper" [ngClass]="{'keyboard-fixed': appState.agent.currentConversation().length > 0}">

     <div id="input-assist" class="input-assist-wrapper" *ngIf="appState.agent.showInputAssist()">
          <div class="content">
            <app-svg-loader class="left-arrow" height="14px" url="assets/svg/chev-bold-right.svg"></app-svg-loader>
            <app-svg-loader class="left-arrow" height="14px" url="assets/svg/chev-bold-right.svg"></app-svg-loader>
            <div class="text">Just tell the agent what to change</div>
            <app-svg-loader class="right-arrow" height="14px" url="assets/svg/chev-bold-right.svg"></app-svg-loader>
            <app-svg-loader class="right-arrow" height="14px" url="assets/svg/chev-bold-right.svg"></app-svg-loader>
          </div>
        </div>

    <ng-container>
        <app-agent-voice-io *ngIf="!isKeyboard"></app-agent-voice-io>

        <app-agent-keyboard-io *ngIf="isKeyboard"
            (onKeyboardFocusChange)="handleKeyboardFocus($event)"></app-agent-keyboard-io>

        <div class="actions-row">
            <div class="action">
                <div class="icon">
                    <app-svg-loader height="20px" *ngIf="!isKeyboard"
                        url="assets/svg/keyboard-solid.svg"></app-svg-loader>
                    <app-svg-loader height="20px" *ngIf="isKeyboard" url="assets/svg/speech-wave.svg"></app-svg-loader>
                </div>
                <div class="text">
                    <p (click)="onToggleInputType()">
                        <span *ngIf="!isKeyboard">Use Keyboard</span>
                        <span *ngIf="isKeyboard">Switch to Voice</span>
                    </p>
                </div>
            </div>
            <div class="action" *ngIf="appState.agent.currentConversation().length > 0">
                <div class="icon">
                    <app-svg-loader height="18px" url="assets/svg/plus-outline.svg"></app-svg-loader>
                </div>
                <div class="text" class="text"
                    (click)="onClickNewConvo()">
                    New Conversation
                </div>
            </div>
        </div>
    </ng-container>

</div>

<app-pop-tray *ngIf="showConfirmNewConvo" [header]="'Start over?'"
    [description]="'This will start a new conversation'" [actions]="confirmationTrayActions">
</app-pop-tray>